/**
 * Request-shaping helpers for the companies-sites endpoints, kept out of the
 * route file so it stays a flat list of calls.
 */

import type { OwnershipScope, SyncProfileOwnershipRequest } from '../types/companies-sites.types';

/**
 * Translates a scope into the profile-ownership sync endpoint's body, and the only
 * place that does.
 *
 * Returns `undefined` for an absent scope so no body is sent at all — the endpoint
 * reads an omitted body as the whole estate, and an empty object would be a
 * different, untested request.
 *
 * The endpoint's three selectors are mutually exclusive, which is why the input is
 * a union: exactly one field can ever be set here, and no caller can express more.
 */
export function ownershipScopeBody(
    scope: OwnershipScope | undefined
): SyncProfileOwnershipRequest | undefined {
    if (!scope) {
        return undefined;
    }

    switch (scope.kind) {
        case 'profile':
            return { profile_uuid: scope.uuid };
        case 'site':
            return { site_uuid: scope.uuid };
        case 'company':
            return { company_uuid: scope.uuid };
    }
}
